import { PanelHighlighted } from '../../../../components/CarValuationPage/components/Panel';
import { theme } from '../../../../helpers/Theme';
import * as Styled from '../../../../components/CarValuationPage/components/AllianzInsuranceRenewal/AllianzInsuranceRenewal.styled';
import { PoweredByInfoTitle } from '../../../../components/PoweredBy/PoweredByInfoTitle';
import { Spacer } from '../../../../helpers/genericStyles';

interface AllianzInsuranceRenewalProps {
  children: React.ReactNode;
  showPoweredByLogo?: boolean;
  showSelectSubtext?: boolean;
}

function AllianzInsuranceRenewal(props: AllianzInsuranceRenewalProps) {
  const {
    children,
    showPoweredByLogo = true,
    showSelectSubtext = true,
  } = props;
  return (
    <PanelHighlighted>
      <PoweredByInfoTitle
        title={'Get the latest Allianz car insurance offers on DoneDeal'}
        description={'At a time that suits you'}
        showPoweredByLogo={showPoweredByLogo}
      />
      <Spacer marginBottom={'M16'} />
      {children}
      {showSelectSubtext && (
        <Styled.SubText>
          <Styled.SInformationCircleOutlineIc
            height="16"
            width="16"
            color={theme.colors.BLUE}
          />
          <Styled.Text>
            This information will be saved to your DoneDeal profile
          </Styled.Text>
        </Styled.SubText>
      )}
    </PanelHighlighted>
  );
}

export { AllianzInsuranceRenewal };
